import React, { Component } from 'react';
import { Row, Col, Dropdown } from "react-bootstrap";
import './LoginView.scss';
import Select from 'react-select';
/*-- Import required components --*/
import Timer from './Timer';
import { Button, FlagDropDown } from "../common";
import { get, post } from './../../utility/apiClient';
import { errorTypesEnum } from './../../utility/enums';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';
import { GtagEvent } from './../../utility/googleAnalytics';

/**-- Imports for redux --*/
import { connect } from 'react-redux';
import { showPopupBox, resetPopupBox } from '../../redux/actions/popupBoxActions';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';
import { addUserDetail } from '../../redux/actions/userDetailsActions';
import UserGuiderSuccess from '../common/userGuider/UserGuiderSuccess';
import { addPreference } from '../../redux/actions/preferenceActions';
import { countries } from '../common/flagDropDown/countries';
import { resetUserRedirect } from '../../redux/actions/userRedirectActions';
import { updateIsTemporaryCart } from '../../redux/actions/userDetailsActions';
import { resetWebDataCollection } from '../../redux/actions/webDataCollectionActions';

// map the redux states to props
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
        loadingScreenVisible: state.loadingScreen,
        customerData: state.customerDetail,
        selectedEssentialPackagesList: state.selectedEssentialPackages,
        systemConfigurationData: state.systemConfiguration,
        userData: state.userDetails,
        userRedirect: state.userRedirect,
        preferenceModal: state.preferenceModal

    }
};

// map the redux actions to props
const mapDispatchToProps = {
    showMessageBox,
    resetPopupBox,
    showLoadingScreen,
    hideLoadingScreen,
    addUserDetail,
    showPopupBox,
    addPreference,
    resetUserRedirect,
    updateIsTemporaryCart,
    resetWebDataCollection
};

class LoginView extends Component {
    state = {
        UserName: '',
        Password: '',
        MobileNumber: '',
        OTPNumber: '',
        isRequestSent: false,
        isDisabledResend: false,
        RemainTime: '',

        // validations
        isCheckingLoginValidity: false,
        isCheckingOTPValidity: false,
        isCheckingMobileNumberValidity: false,
        isCountryNotAllowed: false,

        isUserNameNotValid: true,
        isPasswordNotValid: true,
        isMobileNumberNotValid: true,
        isOTPNotValid: true,
        isWrongEmailAddress: true,

        // keys
        timerKey: 0,
        OTPKey: '',

        countryList: [],
        countryKey: 0,
        selectedCountry: 'LK',
        countryplaceholder: "Sri Lanka"
    }

    constructor(props) {
        super(props);
        this.VerifyPhoneNumber = this.VerifyPhoneNumber.bind(this);
        this.phoneNumberInput = React.createRef();
    }

    componentDidMount() {
        this.loadCountryCodes();
        this.props.resetWebDataCollection();
    }

    loadCountryCodes() {
        get("/Common/GetCountryCodes").then(response => {
            if (response.data.statusCode == 200) {
                let cityList = response.data.result.map(i => {
                    return {
                        value: i.countryCode,
                        label: i.countryName
                    };
                });
                if (response.data.result) {
                    this.setState({
                        countryList: cityList,
                    }, () => { })
                }
            } else {

            }
        })
    }

    LoginValidate() {
        let isFailed = false;
        if (this.state.UserName === '') {
            this.setState({ isCheckingLoginValidity: true, isUserNameNotValid: true, isWrongEmailAddress: false });
            isFailed = true;
        }
        else if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(this.state.UserName)) { this.setState({ isCheckingLoginValidity: true, isUserNameNotValid: false, isWrongEmailAddress: true }); isFailed = true; }

        else {
            this.setState({ isCheckingLoginValidity: true, isUserNameNotValid: false, isWrongEmailAddress: false });
        }

        if (this.state.Password === '') {
            this.setState({ isCheckingLoginValidity: true, isPasswordNotValid: true })
            isFailed = true;
        }
        else {
            this.setState({ isCheckingLoginValidity: true, isPasswordNotValid: false });
        }
        return isFailed;
    };

    Login() {
        if (!this.LoginValidate()) {
            this.props.showLoadingScreen();
            let formData = {
                "Username": this.state.UserName,
                "Password": this.state.Password
            }
            post(`/Login/CredentialLogin`, formData).then(response => {
                if (response.data.statusCode === 200) {
                    if (response.data.result === "KOL177")//Session Exceed
                    {
                        let popupBox = {
                            show: true,
                            imageURL: "https://essstr.blob.core.windows.net/uiimg/PopupBox/SessionExceed.png",
                            themeColor: "",
                            buttonText1: "Browse the store",
                            buttonText2: "",
                            isConfirmation: true,
                            callBackFunction: (response) => { if (response) { this.props.guestLogin(); } }
                        }
                        this.props.showPopupBox(popupBox);
                    } else if (response.data.result === "KOL178")//Session Exceed
                    {
                        let popupBox = {
                            show: true,
                            imageURL: "https://essstr.blob.core.windows.net/uiimg/PopupBox/AllOutletQuotaExceed.png",
                            themeColor: "",
                            buttonText1: "Browse the store",
                            buttonText2: "",
                            isConfirmation: true,
                            callBackFunction: (response) => { if (response) { this.props.guestLogin(); } }
                        }
                        this.props.showPopupBox(popupBox);
                    }
                    else if (response.data.result === "KOL265")//Site offline for maintainance
                    {
                        let popupBox = {
                            show: true,
                            imageURL: "https://essstr.blob.core.windows.net/uiimg/PopupBox/Maintenance.png",
                            themeColor: "",
                            buttonText1: "",
                            buttonText2: "",
                            isConfirmation: false,
                            //callBackFunction: (response) => { if (response) { this.props.guestLogin(); } }
                        }
                        this.props.showPopupBox(popupBox);
                    }
                    else if (response.data.result.migrationVerified) {
                        this.props.addUserDetail(response.data.result).then(() => {
                            //   GtagEvent({ action: 'login', category: 'form', label: 'Existing user login via email' });
                            if (response.data.result.isPremiumCustomer) {
                                this.PremiumCustomerFn();
                            }
                            else {
                                this.props.onLogin();
                            }
                        })
                    } else {
                        this.props.addUserDetail(response.data.result).then(() => {
                            this.props.onForgetPassword();
                        })
                    }
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    PremiumCustomerFn() {
        this.props.showLoadingScreen();
        get("/Web/GetDeliveryPreferences")
            .then(response => {
                if (response.data.statusCode == 200) {
                    let result = response.data.result;
                    let outlet = result.deliverySuburbsList.find(x => x.branchCode === this.props.userData.premiumOutlet);
                    if (outlet) {
                        let suburb = result.deliverySuburbsList.find(x => x.cityId === outlet.cityId);
                        if (this.isQuotaFull(suburb)) {
                            //   GtagEvent({ action: 'submit', category: 'form', label: 'Shipping method delivery' });
                            let data = {
                                outletCode: outlet.maxOrdersReached ? outlet.substituteOutletCode : outlet.branchCode,
                                outletName: outlet.maxOrdersReached ? outlet.substituteOutletDescription : outlet.branchName,
                                shoppingMethod: "Delivery",
                                mainOutletCode: outlet.branchCode,
                                mainOutletDescription: outlet.branchName,
                                suburbID: outlet.cityId,
                                availableDeliveryDates: outlet.availableDeliveryDates,
                                maxOrdersReached: outlet.maxOrdersReached,
                            }
                            this.props.addPreference(data).then(() => {
                                this.props.hideLoadingScreen();
                                let userRedirect = this.props.userRedirect
                                if (userRedirect.redirectUrl) {
                                    this.props.updateIsTemporaryCart(false);
                                    this.props.resetUserRedirect().then(() => {
                                        window.location.replace(userRedirect.redirectUrl);
                                    });
                                }
                                else {
                                    window.location.replace("/");
                                }

                            })
                        }
                        else {
                            this.props.onLogin();
                        }
                    }
                    else {
                        this.props.onLogin();
                    }
                    this.props.hideLoadingScreen();
                }
            })
    }

    isQuotaFull(suburb) {
        let suburbMaxOrdersReached = suburb.availableDeliveryDates.availableDateRange.filter(x => x.maxOrdersReached === false).length > 0 ? false : true;
        if (suburbMaxOrdersReached && suburbMaxOrdersReached != undefined) {
            if (suburb.branchCode === suburb.substituteOutletCode) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    }

    MobileNumberValidate() {
        let isFailed = false;
        if (this.state.MobileNumber === '') {
            this.setState({ isCheckingMobileNumberValidity: true, isMobileNumberNotValid: true });
            isFailed = true;
        }
        else {
            this.setState({ isMobileNumberNotValid: false });
        }
        return isFailed;
    };

    VerifyPhoneNumber() {
        if (!this.MobileNumberValidate()) {
            this.props.showLoadingScreen();
            get(`/Login/SendLoginOTP?mobileNumber=${this.state.MobileNumber}&reference=${this.state.OTPKey}`).then(response => {
                if (response.data.statusCode === 200) {

                    if (response.data.result === "KOL177")//Session Exceed
                    {
                        let popupBox = {
                            show: true,
                            imageURL: "https://essstr.blob.core.windows.net/uiimg/PopupBox/SessionExceed.png",
                            themeColor: "",
                            buttonText1: "Browse the store",
                            buttonText2: "",
                            isConfirmation: true,
                            callBackFunction: (response) => { if (response) { this.props.guestLogin(); } }
                        }
                        this.props.showPopupBox(popupBox);
                    } else if (response.data.result === "KOL178")//Session Exceed
                    {
                        let popupBox = {
                            show: true,
                            imageURL: "https://essstr.blob.core.windows.net/uiimg/PopupBox/AllOutletQuotaExceed.png",
                            themeColor: "",
                            buttonText1: "Browse the store",
                            buttonText2: "",
                            isConfirmation: true,
                            callBackFunction: (response) => { if (response) { this.props.guestLogin(); } }
                        }
                        this.props.showPopupBox(popupBox);
                    } else if (response.data.result === "KOL265")//Site offline for maintainance
                    {
                        let popupBox = {
                            show: true,
                            imageURL: "https://essstr.blob.core.windows.net/uiimg/PopupBox/Maintenance.png",
                            themeColor: "",
                            buttonText1: "",
                            buttonText2: "",
                            isConfirmation: false,
                            //callBackFunction: (response) => { if (response) { this.props.guestLogin(); } }
                        }
                        this.props.showPopupBox(popupBox);
                    }
                    else {
                        this.setState({
                            isRequestSent: true,
                            isDisabledResend: true,
                            OTPKey: response.data.result.otpKey,
                            timerKey: this.state.timerKey + 1,
                        })
                    }
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    OTPValidate() {
        let isFailed = false;

        if (this.state.OTPNumber === '') {
            this.setState({ isCheckingOTPValidity: true, isOTPNotValid: true })
            isFailed = true;
        }
        else {
            this.setState({ isOTPNotValid: false });
        }
        return isFailed;
    };

    VerifyOTPNumber() {
        if (!this.OTPValidate()) {
            this.props.showLoadingScreen();
            get(`/Login/ValidateLoginOTP?reference=${this.state.OTPKey}&otp=${this.state.OTPNumber}`).then(response => {
                if (response.data.statusCode === 200) {
                    this.props.addUserDetail(response.data.result).then(() => {
                        // GtagEvent({ action: 'login', category: 'form', label: 'Existing user login via mobile number' });
                        if (response.data.result.isPremiumCustomer) {
                            this.PremiumCustomerFn();
                        }
                        else {
                            this.props.onLogin();
                        }
                    })
                } else {
                    let errorType = response.data.errorList[0].errorType;
                    let messageBox = {
                        show: true,
                        title: errorTypesEnum.error === errorType ? "Oops!" : errorTypesEnum.warning === errorType ? "Warning" : "Information",
                        className: errorTypesEnum.error === errorType ? "error" : errorTypesEnum.warning === errorType ? "warning" : "info",
                        content: response.data.errorList[0].statusMessage,
                        isConfirmation: false,
                        callBackFunction: null
                    }
                    this.props.showMessageBox(messageBox);
                }
                this.props.hideLoadingScreen();
            })
        }
    };

    onChangeSetState(e) {
        let valid = true;
        if (e.target.name == "MobileNumber") {
            if (!(/^[0-9]+$/.test(e.target.value) || e.target.value == '')) {
                valid = false;
            }
        }

        if (e.target.name == "UserName") {
            e.target.value = e.target.value.toLowerCase();
        }

        if (valid) {
            this.setState({ [e.target.name]: e.target.value }, () => {
                if (this.state.isCheckingLoginValidity) { this.LoginValidate(); }
                if (this.state.isCheckingOTPValidity) { this.OTPValidate(); }
                if (this.state.isCheckingMobileNumberValidity) { this.MobileNumberValidate(); }
            })
        }
    };

    passwordVisibility() {
        var passwordField = document.getElementById("Password");
        var pwVisibleIcon = document.getElementById("pw-visible-icon");
        if (passwordField.type === "password") {
            passwordField.type = "text";
            pwVisibleIcon.classList.replace("fa-eye-slash", "fa-eye");
        } else {
            passwordField.type = "password";
            pwVisibleIcon.classList.replace("fa-eye", "fa-eye-slash");
        }
    };

    handleCountryChange(e) {
        this.setState({
            isCountryNotAllowed: e.value !== 'LK',
            selectedCountry: e.value,
            countryKey: this.state.countryKey + 1,
            countryplaceholder: e.label
        })
    };

    render() {
        return (
            <Col className={`login-container ${this.props.isVisible ? '' : 'd-none'}`} lg="10" md="10" sm="12" xs="12">
                <UserGuiderSuccess
                    isMobile={this.props.responsive.isTabScreen || this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen ? true : false}
                    name='LoginPhonePop'
                    target={this.phoneNumberInput}
                    placement='top'
                    expirytime={30000}
                    content='You can login with your Nexus number/ Mobile number only if it is verified with our website. If its not, kindly use your email to login. You can verify your number once you enter the site in the My account section.'
                />
                <div className='gray-section'>
                    <Col>
                        <img src={KeellsLogo} className="img-fluid" /> <br /> <br />
                        <span className='small-title white'><b>Log In</b></span>
                        <br />  <br />
                        <span className='description white'>Shopped with us before? Log in with your details</span>
                    </Col>
                    <Col>
                        {
                            (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
                                '' :
                                <React.Fragment>
                                    <span className='description white'>New member?</span><br />
                                    <Button primary onClick={this.props.onRegisterClick} className="mb-3" >Click here to register</Button>
                                    <br /><span className='description white'>Have trouble logging in? Call us on <a href="tel:+940112303500" style={{ color: "#64bf47" }}>0112303500</a> (Daily operating hours 8.00a.m to 8.00p.m)
                                    </span>
                                </React.Fragment>
                        }
                    </Col>
                </div>

                <div className='white-section'>
                    <Col>
                        <div className='row'>

                            <div className="form-group col">
                                <label htmlFor="UserName" className='black'>Email</label>
                                <div className="input-group">
                                    <input name="UserName" placeholder="Email" type="text"
                                        onChange={this.onChangeSetState.bind(this)}
                                        className="form-control set-height-55" />
                                </div>
                                <span className={`form-text text-muted col ${this.state.isUserNameNotValid && this.state.isCheckingLoginValidity ? '' : 'd-none'}`}> Email is required.</span>
                                <span className={`form-text text-muted col ${this.state.isWrongEmailAddress && this.state.isCheckingLoginValidity ? '' : 'd-none'}`}> Invalid email address.</span>
                                <div className='mt-3' style={{ fontSize: '0.97rem' }}>
                                    <a href='/welcome/Registration'>
                                        <span className="form-group green">
                                            <i className="fas fa-info-circle"></i> New here? Sign up with your email/phone number to get started.
                                        </span>
                                    </a>
                                </div>
                            </div>

                            <div className="form-group col">
                                <label htmlFor="Password" className='black'>Password</label>
                                <div className="input-group" style={{ marginBottom: 0 }}>
                                    <input id="Password" name="Password" placeholder="Password" type="password"
                                        onChange={this.onChangeSetState.bind(this)}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) this.Login()
                                        }}
                                        className="form-control set-height-55" />
                                    <i id="pw-visible-icon" className="fas fa-eye-slash" onClick={this.passwordVisibility.bind(this)} />
                                </div>
                                <span
                                    className={`form-text text-muted col ${this.state.isPasswordNotValid && this.state.isCheckingLoginValidity ? '' : 'd-none'}`}>
                                    Password is required.</span>
                                <span className="form-text forget-pwd" onClick={this.props.onForgetPassword}>Forgot Password?</span>

                            </div>

                        </div>
                        <div className="form-group">
                            <Button primary floatRight onClick={this.Login.bind(this)}>Log In</Button>
                        </div>
                    </Col>
                    <Col>
                        <hr />
                        <span className='description black no-margin font-weight-bold'>Or log in with your mobile number</span><br /><br />

                        {
                            (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
                                <div className='row'>
                                    <div className="form-group col" ref={this.phoneNumberInput}>
                                        <label className='black' htmlFor="MobileNumber">Enter your Nexus mobile or Mobile number</label>
                                        <div className="input-group" >

                                            <div className="input-group-prepend set-height-57" style={{ width: "100%" }}>

                                                <div className="">
                                                    <div style={{ width: '13rem' }}>
                                                        <Select options={this.state.countryList}
                                                            key={this.state.countryKey}
                                                            value={this.state.selectedCountry}
                                                            placeholder={this.state.countryplaceholder}
                                                            onChange={this.handleCountryChange.bind(this)}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: '0px 0px 0px 1.375rem',
                                                                height: '10px'
                                                            })}
                                                        />

                                                    </div>
                                                    <li className="custom-border" />
                                                </div>

                                                <input name="MobileNumber"
                                                    placeholder={`${this.state.isCountryNotAllowed ? 'Mobile Number' : '07XXXXXXXX'}`}
                                                    type="text"
                                                    style={{ margin: 0, }}
                                                    onChange={this.onChangeSetState.bind(this)}
                                                    disabled={this.state.isCountryNotAllowed}
                                                    className="form-control right-margin-15 set-height-55 no-left-radius no-left-border MobileInputHeight"
                                                    value={this.state.MobileNumber}
                                                    autoComplete="off"
                                                    maxLength={!this.state.isCountryNotAllowed ? 10 : 50} />
                                            </div>

                                            <Button secondary floatRight
                                                onClick={this.VerifyPhoneNumber.bind(this)}
                                                disabled={this.state.isDisabledResend || this.state.isCountryNotAllowed}
                                            >{`${this.state.isRequestSent ? 'Resend' : 'Verify Number'}`}</Button>


                                        </div>
                                        <span
                                            className={`form-text text-muted col ${this.state.isMobileNumberNotValid && this.state.isCheckingMobileNumberValidity ? '' : 'd-none'}`}
                                        >Nexus mobile number is required</span>
                                        <span
                                            className={`form-text text-muted col ${this.state.isCountryNotAllowed ? '' : 'd-none'}`}
                                        >Hello, Sorry we do not have OTP authentication for numbers outside of Sri Lanka, please proceed using your email credentials.</span>
                                    </div>
                                </div>
                                : // desktop
                                <div className='row'>
                                    <div className="form-group col">
                                        <label className='black' htmlFor="MobileNumber">Enter your Nexus mobile or Mobile number</label>
                                        <div className="input-group" ref={this.phoneNumberInput}>
                                            <div className="input-group-prepend set-height-55">
                                                <div style={{ width: '12rem' }}>
                                                    <Select options={this.state.countryList}
                                                        key={this.state.countryKey}
                                                        value={this.state.selectedCountry}
                                                        placeholder={this.state.countryplaceholder}
                                                        onChange={this.handleCountryChange.bind(this)}
                                                        theme={theme => ({
                                                            ...theme,
                                                            borderRadius: '0px 0px 0px 25px',
                                                        })}
                                                    />
                                                </div>

                                            </div>
                                            <input
                                                name="MobileNumber"
                                                placeholder={`${this.state.isCountryNotAllowed ? 'Mobile Number' : '07XXXXXXXX'}`}
                                                type="text"
                                                autoComplete="off"
                                                onChange={this.onChangeSetState.bind(this)}
                                                disabled={this.state.isCountryNotAllowed}
                                                className="form-control right-margin-15 set-height-55 no-left-radius no-left-border DesktopInputHeight"
                                                value={this.state.MobileNumber}
                                                maxLength={!this.state.isCountryNotAllowed ? 10 : 50} />
                                            <Button secondary floatRight
                                                onClick={this.VerifyPhoneNumber.bind(this)}
                                                disabled={this.state.isDisabledResend || this.state.isCountryNotAllowed}
                                            >{`${this.state.isRequestSent ? 'Resend' : 'Verify Number'}`}</Button>
                                        </div>
                                        <span
                                            className={`form-text text-muted col ${this.state.isMobileNumberNotValid && this.state.isCheckingMobileNumberValidity ? '' : 'd-none'}`}
                                        >Nexus mobile number is required</span>
                                        <span
                                            className={`form-text text-muted col ${this.state.isCountryNotAllowed ? '' : 'd-none'}`}
                                        >Hello, Sorry we do not have OTP authentication for numbers outside of Sri Lanka, please proceed using your email credentials.  </span>
                                    </div>
                                </div>
                        }

                        {
                            (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
                                <div className='row'>
                                    <div className="form-group col">
                                        <div className={`input-group`} >
                                            <label className='black' htmlFor="OTPNumber">OTP Number</label>
                                            <input
                                                disabled={!this.state.isRequestSent || !this.state.isDisabledResend}
                                                style={{ marginBottom: 10 }}
                                                autoComplete='off'
                                                maxLength={4}
                                                minLength={4}
                                                style={{ marginRight: "0rem" }}
                                                onChange={this.onChangeSetState.bind(this)}
                                                name="OTPNumber" placeholder="OTP Number" type="text"
                                                className="form-control right-margin-15 set-height-55" />
                                            <Timer key={this.state.timerKey}
                                                minutes={2}
                                                seconds={0}
                                                enableTimer={this.state.isRequestSent}
                                                callForResend={() => { this.setState({ isDisabledResend: false, OTPNumber: '' }) }}
                                            />
                                            <span
                                                className={`form-text text-muted col-md-12 col-12 ${this.state.isOTPNotValid && this.state.isCheckingOTPValidity ? '' : 'd-none'}`}
                                            >OTP is required</span>

                                            <Button secondary
                                                disabled={!this.state.isRequestSent || !this.state.isDisabledResend}
                                                onClick={this.VerifyOTPNumber.bind(this)}
                                            >Submit</Button>
                                        </div>
                                    </div>
                                </div>
                                :
                                // Desktop
                                <div className="row form-group col mt-1">
                                    <label className='black' htmlFor="OTPNumber">OTP Number</label>
                                    <div className={`input-group`}>
                                        <Row style={{ width: '100%' }}>
                                            <Col lg={6}>
                                                <input
                                                    disabled={!this.state.isRequestSent || !this.state.isDisabledResend}
                                                    style={{ marginBottom: 10 }}
                                                    autoComplete='off'
                                                    maxLength={4}
                                                    minLength={4}
                                                    onChange={this.onChangeSetState.bind(this)}
                                                    name="OTPNumber" placeholder="OTP Number" type="text"
                                                    className="form-control right-margin-15 set-height-55" />
                                                <Timer key={this.state.timerKey}
                                                    minutes={2}
                                                    seconds={0}
                                                    enableTimer={this.state.isRequestSent}
                                                    callForResend={() => { this.setState({ isDisabledResend: false, OTPNumber: '' }) }}
                                                />
                                                <span
                                                    className={`form-text text-muted col-md-12 col-12 ${this.state.isOTPNotValid && this.state.isCheckingOTPValidity ? '' : 'd-none'}`}
                                                >OTP is required</span>
                                            </Col>
                                            <Col lg={6}>
                                                <Button secondary
                                                    disabled={!this.state.isRequestSent || !this.state.isDisabledResend}
                                                    onClick={this.VerifyOTPNumber.bind(this)}
                                                >Submit</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                        }
                        <div>
                            <Col style={{ textAlign: "center" }}>
                                {
                                    (this.props.responsive.isMobileLargeScreen || this.props.responsive.isMobileSmallScreen) ?
                                        <React.Fragment>
                                            <hr />
                                            <span className='description black'>New member?</span><br />
                                            <Button primary onClick={this.props.onRegisterClick} style={{ marginRight: "auto" }} className="mb-3">Click here to register</Button>
                                            <span className='description black'>Have trouble logging in? Call us on <a href="tel:+940112303500" style={{ color: "#64bf47" }}>0112303500</a> (Daily operating hours 8.00a.m to 8.00p.m)
                                            </span>
                                        </React.Fragment> :
                                        ''
                                }
                            </Col>
                        </div>
                        {/* <div className="form-group">
                  <Button primary>Log In</Button>
                  <Button white append icon='fas fa-angle-right'>View Fresh Deals</Button>
                </div> */}
                        {/* </form> */}
                    </Col>
                </div>
            </Col>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);